module.exports = __webpack_public_path__ + "static/media/projects.5ac243de.gif";